﻿import { api } from '@cwd/lib/main';
import { type TextMessage, type PrePaidBalance, type Keyword, type SmsDialog, type Response } from './TextMessagesTypes';

export async function loadTextMessage(id: string): Promise<TextMessage> {
    return api.get(`/TextMessages/` + id);
}

export async function loadDrafts(): Promise<TextMessage[]> {
    return api.get(`/TextMessages/Drafts`);
}

export async function loadPaused(): Promise<TextMessage[]> {
    return api.get(`/TextMessages/Paused`);
}

export async function loadScheduled(): Promise<TextMessage[]> {
    return api.get(`/TextMessages/Scheduled`);
}

export async function loadSending(): Promise<TextMessage[]> {
    return api.get(`/TextMessages/Sending`);
}

export async function loadSent(): Promise<TextMessage[]> {
    return api.get(`/TextMessages/Sent`);
}

export async function deleteSelected(list: { SmsMessageId: string }[]): Promise<string> {
    return api.delete(`/Textmessages`, list);
}

export async function loadStatisticsCount(): Promise<{
    Paused: number;
    Scheduled: number;
    Sent: number;
}> {
    return api.get('/TextMessages/SmsStatisticsCount');
}

export async function abortSending(id: string): Promise<TextMessage> {
    return api.post('/Textmessages/' + id + '/Abort');
}

export async function changeStatus(id: string, status: number): Promise<TextMessage> {
    return api.post('/Textmessages/' + id + '/Status', status);
}

export async function createNew(): Promise<TextMessage> {
    return api.post('/Textmessages/');
}

export async function loadPrePaidBalance(): Promise<PrePaidBalance> {
    return api.get('/Accounts/Current/PrePaidBalance');
}

export async function loadResponses(): Promise<Response[]> {
    return api.get('/Textmessages/SmsRecived');
}

export async function loadKeywords(): Promise<Keyword[]> {
    return api.get('/Textmessages/Keywords');
}

export async function createKeyword(keyword: string, listId: string): Promise<void> {
    return api.post('/Textmessages/Keywords', { Keyword: keyword, ListId: listId });
}

export async function deleteKeyword(keywordId: string) {
    return api.post('/Textmessages/Keywords/' + keywordId + '/Delete');
}

export async function loadSmsDialogs(): Promise<SmsDialog[]> {
    return api.get('/SmsDialog');
}
